'use client';

import {useLocale} from 'next-intl';
import {usePathname} from 'next/navigation';

const languages = [
  {code: 'fr', label: 'FR', full: 'Francais'},
  {code: 'ar', label: 'عر', full: 'العربية'},
  {code: 'en', label: 'EN', full: 'English'},
] as const;

export default function LanguageSwitcher() {
  const locale = useLocale();
  const pathname = usePathname();

  function switchLocale(newLocale: string) {
    const segments = pathname.split('/');
    segments[1] = newLocale;
    window.location.href = segments.join('/');
  }

  return (
    <div className="flex items-center gap-0.5">
      {languages.map(({code, label, full}) => (
        <button
          key={code}
          onClick={() => switchLocale(code)}
          className={`px-2 py-1 text-xs font-medium rounded transition-colors cursor-pointer ${
            locale === code
              ? 'text-primary font-bold underline underline-offset-2'
              : 'text-muted hover:text-primary'
          }`}
          aria-label={full}
          title={full}
        >
          {label}
        </button>
      ))}
    </div>
  );
}
